document.addEventListener("DOMContentLoaded", function () {
  const hasShownOtp = sessionStorage.getItem("hasShownOtp");
  const form = document.getElementById("customer_login");
  const emailInput = document.getElementById("CustomerEmail");
  const passwordInput = document.getElementById("CustomerPassword");
  const loginButton = document.querySelector(".login_validation-button");
  const recaptchaErrorDiv = document.querySelector(".captcha-alert");
  const otpLoginButton = document.querySelector('.otp-login_validation');
  const accountDropDownLogin = document.querySelector('.account-dropdwon .login-button');
  const passwordLoginButton = document.querySelector('.password-login_validation');
  const recaptchaCloseBtn = recaptchaErrorDiv?.querySelector("span[aria-hidden='true']");
  const recaptchaCloseBtnLogin = document.querySelector(".login-close_button");
  const emailError = emailInput.closest(".input-wrapper").nextElementSibling;
  const passwordError = passwordInput.closest(".input-wrapper").nextElementSibling;
  const formMessage = document.querySelector(".form__message");
  const errorsDiv = document.querySelector(".errors");
  const recoverPassLink = document.querySelector(".recover-pass");

  function validateEmail(email) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }

  function showError(errorElement, message) {
    if (errorElement) {
      errorElement.textContent = message;
      errorElement.style.display = "block";
    }

    if (formMessage) formMessage.classList.add("hidden");
    if (errorsDiv) errorsDiv.classList.add("hidden");
  }

  function clearError(errorElement) {
    if (errorElement) {
      errorElement.textContent = "";
      errorElement.style.display = "none";
    }
  }

   if (recaptchaCloseBtnLogin) {
    recaptchaCloseBtnLogin.addEventListener("click", function () {
      document.querySelector('.form__message').classList.add("hidden");
    });
  }

  // Prevent Enter key from submitting the form
  form.addEventListener("keydown", function (event) {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  });

  loginButton.addEventListener("click", function (event) {
    event.preventDefault();
    let isValid = true;

    if (formMessage) formMessage.classList.add("hidden");
    if (errorsDiv) errorsDiv.classList.add("hidden");

    if (emailInput.value.trim() === "") {
      showError(emailError, "Bitte geben Sie Ihre E-mail an");
      isValid = false;
    } else if (!validateEmail(emailInput.value.trim())) {
      showError(emailError, "Bitte geben Sie eine gültige E-Mail Adresse ein");
      isValid = false;
    } else {
      clearError(emailError);
    }

    if (isValid && passwordInput.value.trim() === "") {
      showError(passwordError, "Bitte geben Sie Ihr Passwort ein");
      isValid = false;
    } else {
      clearError(passwordError);
    }

    if (isValid) {
      let recaptchaResponse = grecaptcha.getResponse();
      if (!recaptchaResponse) {
        recaptchaErrorDiv.classList.remove("hidden");
        isValid = false;
      } else {
        recaptchaErrorDiv.classList.add("hidden");
      }
    }

    if (isValid) {
      form.submit();
    }
  });

  if (recoverPassLink) {
    recoverPassLink.addEventListener("click", function () {
      recaptchaErrorDiv.classList.add("hidden");
    });
  }

  // ✅ only call once if not shown before
  if (!hasShownOtp) {
    showOtpLoginSection();
    sessionStorage.setItem("hasShownOtp", "true"); // mark as shown
  }

  if (otpLoginButton) {
    otpLoginButton.addEventListener('click', showOtpLoginSection);
  }

  function showOtpLoginSection() {
    document.querySelector('.login-container.grid__item').classList.add('hidden');
    document.querySelector('.otp-login-container').classList.remove('hidden');
    document.querySelector('#generate-otp-btn').classList.remove('hidden');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  if (passwordLoginButton) {
    const alertBox = document.getElementById("emailnotreg");
    const errorMessage = document.querySelector(".otp-error_message");
    passwordLoginButton.addEventListener('click', () => {
      document.querySelector('.login-container.grid__item').classList.remove('hidden');
      document.querySelector('.otp-login-container').classList.add('hidden');
      document.querySelector(".verify-otp_button").classList.add("hidden");
      alertBox.classList.add('hidden');
      errorMessage.textContent = "";
    });
  }

  if (recaptchaCloseBtn) {
    recaptchaCloseBtn.addEventListener("click", function () {
      recaptchaErrorDiv.classList.add("hidden");
    });
  }

  let isRecaptchaOpen = false;
  document.addEventListener("click", function (event) {
    const recaptchaPopup = document.querySelector(".g-recaptcha");
    const recaptchaIframe = document.querySelector(".g-recaptcha-bubble-arrow")?.parentElement;
    const customerLogin = document.querySelector("#customer_login");

    if (recaptchaIframe && recaptchaIframe.style.visibility !== "hidden") {
      isRecaptchaOpen = true;
    } else {
      isRecaptchaOpen = false;
    }

    if (
      isRecaptchaOpen &&
      recaptchaPopup &&
      !recaptchaPopup.contains(event.target) &&
      !customerLogin.contains(event.target)
    ) {
      if (typeof grecaptcha !== "undefined") {
        grecaptcha.reset();
        isRecaptchaOpen = false;
      }
    }
  });
});



document.addEventListener("DOMContentLoaded", function () {
  const recoverForm = document.querySelector("form[action='/account/recover']");
  const recoverEmailInput = document.getElementById("RecoverEmail");
  const recoverButton = document.querySelector(".recover_validation-button");
  const emailError =
    recoverEmailInput.closest(".input-wrapper").nextElementSibling;

  function validateEmail(email) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }

  function showError(errorElement, message) {
    if (errorElement) {
      errorElement.textContent = message;
      errorElement.style.display = "block";
    }
  }

  function clearError(errorElement) {
    if (errorElement) {
      errorElement.textContent = "";
      errorElement.style.display = "none";
    }
  }

  recoverButton.addEventListener("click", function (event) {
    event.preventDefault();
    let isValid = true;

    // Email Validation
    if (recoverEmailInput.value.trim() === "") {
      showError(emailError, "Indtast venligst emailadresse");
      isValid = false;
    } else if (!validateEmail(recoverEmailInput.value.trim())) {
      showError(emailError, "Indtast venligst en gyldig e-mail adresse");
      isValid = false;
    } else {
      clearError(emailError);
    }

    // Submit form if validation passes
    if (isValid) {
      sessionStorage.setItem('recoverEmail', recoverEmailInput.value)
      recoverForm.submit();
    }
  });
});

// Show recover email in success popup 
const recoverEmail = sessionStorage.getItem('recoverEmail');
const successPopupEl = document.querySelector('.recover-password-popup__wrapper .recover-mailid')
const loginWrapper = document.querySelector('.customer-login__wrapper');
if (recoverEmail && successPopupEl) {
  successPopupEl.textContent = recoverEmail;
  if (loginWrapper) {
    loginWrapper.style.display = 'none';
  }
}

// Hide popup 
const backToLogin = document.querySelector('.recover-password-popup__wrapper .recover-password-cancel');
backToLogin?.addEventListener('click', (event) => {
  const popupWrapper = document.querySelector('.recover-password-popup__wrapper');
  event.preventDefault();
  if (loginWrapper) {
    loginWrapper.style.display = 'flex'
  }
  popupWrapper?.classList.add('hidden');
})

// Clear recover input and error message when user click back button
const forgotBackButton = document.querySelector('.login-container .recover-password-cancel');
forgotBackButton?.addEventListener('click', () => {
  const recoverPasswordInput = document.querySelector('.recover_pass #RecoverEmail');
  const errorMessage = document.querySelector('.recover_pass .error_message');
  recoverPasswordInput.value = '';
  errorMessage.textContent = '';
})

// clear login inputs and error messages when user click forgot password 
const forgotPassword = document.querySelector('#customer_login .recover-pass');
forgotPassword?.addEventListener('click', () => {
  const loginInputs = document.querySelectorAll('#customer_login input');
  const loginErrormessages = document.querySelectorAll('#customer_login .error_message');
  loginInputs?.forEach((each) => each.value = '');
  loginErrormessages?.forEach((each) => each.textContent = '');
})